import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useTourStop } from "@/libs/tours-detail/hooks/useTourStop";
import { ChevronLeft } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router";

export function DropOffDetailPage() {
  const { t } = useTranslation();

  const [note, setNote] = useState("");

  const { id, stopId, taskId } = useParams<{
    id: string;
    stopId: string;
    taskId: string;
  }>();

  const { currentStop, handleGatherDropOff, handleGatherDropoffFailed } =
    useTourStop(stopId as string);

  const navigate = useNavigate();

  const currentTask = currentStop?.items.find(
    (item) => item.id === (taskId as string),
  );

  const lastStopRoute = routePaths.createTourStopPath(
    currentTask?.parentId as string,
    currentTask?.id as string,
    currentTask?.type as string,
  );

  return (
    <div className="h-screen">
      <div className="h-full flex flex-col">
        <div className="bg-white px-4 py-6 border-b-2 border-neutral pt-safe">
          <Link
            to={lastStopRoute}
            className="mb-8 flex items-center font-medium gap-1.5 bg-slate-100 w-fit p-2 pr-4 rounded"
          >
            <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
            {t("common.back")}
          </Link>

          <div className="space-y-2">
            <h3 className="text-xl font-semibold">
              {t("gatherDropoff.header.title")}
            </h3>
          </div>
        </div>

        <div className="overflow-y-scroll pb-12 bg-list-background h-full">
          <div className="space-y-4 p-4">
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder={t("gatherDropoff.notePlaceholder")}
              rows={8}
            />
          </div>
        </div>

        <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t-2 border-neutral pb-safe">
          <div className="space-y-4">
            <Button
              className="w-full bg-green-400 hover:bg-green-500 text-black font-semibold"
              onClick={() => {
                handleGatherDropOff(
                  currentTask?.id as string,
                  currentTask?.parentId as string,
                  {
                    driverNote: note,
                  },
                );
                navigate(lastStopRoute);
              }}
            >
              {t("gatherDropoff.dropOff.single")}
            </Button>

            <Button
              className="w-full bg-red-400 hover:bg-red-500 text-black font-semibold"
              onClick={() =>
                handleGatherDropoffFailed(
                  currentTask?.parentId as string,
                  currentTask?.id as string,
                  {
                    driverNote: note,
                  },
                )
              }
            >
              {t("gatherDropoff.dropOff.failed")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
